import GridLayout from "react-grid-layout";

export const VEHICLE_MAINTENANCE_DASHBOARD_LAYOUT_CHANGED =
  "VEHICLE_MAINTENANCE_DASHBOARD_LAYOUT_CHANGED";

export const createVehicleMaintenanceDashboardLayoutChangedAction = (
  payload: GridLayout.Layouts,
  initial: boolean = false
) => {
  return {
    type: VEHICLE_MAINTENANCE_DASHBOARD_LAYOUT_CHANGED,
    payload,
    initial,
  };
};
